/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Erp_Product_TypeInputs */

const en_reference_field_erp_product_type = /** @type {(inputs: Reference_Field_Erp_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Type (file to the ERP)`)
};

/**
* | output |
* | --- |
* | "Product Type (file to the ERP)" |
*
* @param {Reference_Field_Erp_Product_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_erp_product_type = /** @type {((inputs?: Reference_Field_Erp_Product_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Erp_Product_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_erp_product_type(inputs)
});